module.exports = __webpack_public_path__ + "static/img/lunbo.d2adc33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_1/lunbo.jpg
// module id = uVA1
// module chunks = 0